import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "config-editor" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$tkey("configEditor")))]),
      _vm._v(" "),
      _c(
        VContainer,
        { attrs: { fluid: "" } },
        [
          _c(
            VRow,
            { attrs: { align: "start" } },
            [
              _c(
                VCol,
                { attrs: { cols: "2" } },
                [
                  _c("vuex-select", {
                    attrs: {
                      options: _vm.getMongoConfigOptions,
                      getter: () => _vm.selectedConfigId,
                      setter: _vm.configSetter,
                      label: _vm.$tkey("selectConfigLabel"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedConfigId
        ? [
            _c(
              VContainer,
              { staticClass: "config-editor__container", attrs: { fluid: "" } },
              [
                _vm._l(_vm.formItems, function (item, itemIndex) {
                  return _c(
                    VRow,
                    {
                      key: "item" + itemIndex,
                      staticClass: "config-editor__container--item",
                      attrs: { align: "start" },
                    },
                    [
                      _vm._l(_vm.formFields, function (field, fieldIndex) {
                        return _c(
                          VCol,
                          {
                            key: "field" + fieldIndex,
                            class:
                              field.fieldType === "boolean"
                                ? "checkbox-field"
                                : "",
                            attrs: {
                              cols: field.fieldType === "boolean" ? 2 : 3,
                            },
                          },
                          [
                            _c(_vm.fieldTypeComponentMap[field.fieldType], {
                              tag: "component",
                              attrs: {
                                getter: () => item[field.fieldName],
                                setter: (value) =>
                                  _vm.itemSetter(value, item, field),
                                label: field.fieldLabel,
                                validations: _vm.showValidation
                                  ? _vm.fieldValidations(field)
                                  : [],
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        VCol,
                        {
                          staticClass: "config-editor__container--delete",
                          attrs: { cols: "1" },
                        },
                        [
                          _c("confirm-dialog", {
                            attrs: {
                              "question-text": _vm.$tkey(
                                "deleteDialogQuestion"
                              ),
                              "action-text": _vm.$tkey("actionText"),
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.deleteSelectedItem(itemIndex)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function ({ activator }) {
                                    return [
                                      _c("delete-button", {
                                        attrs: {
                                          events: activator,
                                          background: "",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  VRow,
                  { attrs: { align: "start" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "1" } },
                      [
                        _c("create-new-button", {
                          attrs: { "btn-text": _vm.$tkey("addNewConfigText") },
                          on: { createNew: _vm.createNew },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      VCol,
                      {
                        staticClass: "text-right",
                        attrs: { cols: "1", offset: "3" },
                      },
                      [
                        _c(
                          "simple-button",
                          {
                            attrs: {
                              "light-theme": false,
                              disabled: !_vm.hasChanges,
                            },
                            on: { onClick: _vm.cancelChanges },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$tkey("cancel")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      VCol,
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "positive-action-button",
                          {
                            attrs: {
                              disabled: !_vm.hasChanges || !_vm.isFormValid,
                            },
                            on: { onClick: _vm.save },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$tkey("save")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }